// extracted by mini-css-extract-plugin
export default {"title":"title__yKGVl","body-text":"body-text__bbXp4"};